import { render, staticRenderFns } from "./QuestionTrivia.vue?vue&type=template&id=0446a289&scoped=true"
import script from "./QuestionTrivia.vue?vue&type=script&lang=js"
export * from "./QuestionTrivia.vue?vue&type=script&lang=js"
import style0 from "./QuestionTrivia.vue?vue&type=style&index=0&id=0446a289&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0446a289",
  null
  
)

export default component.exports